<template>
  <div v-loading="pageLoading">
    <el-form class="full-width mb-2px" :model="filterForm">
      <div class="filter-bar" type="flex">
        <el-form-item class="mb-none">
          <school-year-selector
            v-model="filterForm.schoolYear"
            @change="refresh"
          ></school-year-selector>
        </el-form-item>
        <el-form-item class="mb-none">
          <school-term-selector
            v-model="filterForm.schoolTerm"
            @change="refresh"
            :checkAll="false"
          ></school-term-selector>
        </el-form-item>
        <el-form-item class="mb-none">
          <el-select
            size="small"
            value-key="grade"
            v-model="filterForm.disciplineCode"
            placeholder="请选择学科"
            clearable
            @change="refresh"
          >
            <el-option
              v-for="item in disciplineOptions"
              :value="item.disciplineCode"
              :label="item.disciplineName"
              :key="item.disciplineCode"
            ></el-option
          ></el-select>
        </el-form-item>
        <el-form-item class="mb-none">
          <el-select
            size="small"
            value-key="grade"
            v-model="filterForm.grade"
            placeholder="请选择年级"
            clearable
            @change="refresh"
          >
            <el-option
              v-for="item in gradeOptions"
              :value="{ grade: item.grade, gradeName: item.gradeName }"
              :key="item.grade"
              :label="item.gradeName"
            ></el-option
          ></el-select>
        </el-form-item>
        <el-form-item class="mb-none">
          <el-input
            size="small"
            v-model="filterForm.keyword"
            clearable
            placeholder="搜索教师姓名/教研组名称"
            style="width: 250px"
            @keydown.enter="refresh"
            @change="refresh"
          >
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
          </el-input>
        </el-form-item>
        <el-button size="small" type="primary" @click="onReset">重置</el-button>
        <div class="space"></div>
        <el-button
          size="small"
          type="primary"
          icon="el-icon-plus"
          @click="onAdd"
          v-if="userInfo.roleCodes.includes('admin')"
          >创建教研组</el-button
        >
      </div></el-form
    >
    <div class="data-list" v-loading="pageLoading">
      <card-list
        moduleType="researchGroup"
        :dataList="tableData"
        @delSuccess="refresh"
        @toPathEdit="toPathEdit"
      ></card-list>
    </div>

    <pagination
      class="mb-md mr-md"
      slot="append"
      :pageObj="filterForm"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
    ></pagination>
    <el-dialog
      :title="dialogForm.id == null ? '新增教研组' : '编辑教研组'"
      :visible.sync="dialogShow"
      @closed="onDialogClose"
      :modal="false"
    >
      <el-form
        v-loading="saving"
        label-width="140px"
        ref="dialogForm"
        :model="dialogForm"
        :rules="rules"
      >
        <el-form-item label="教研组名称" prop="groupName">
          <el-input
            v-model="dialogForm.groupName"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item prop="schoolYear" label="学年">
          <school-year-selector
            v-model="dialogForm.schoolYear"
            @change="refreshSchoolYear"
          ></school-year-selector>
        </el-form-item>
        <el-form-item label="学期" prop="schoolTerm">
          <school-term-selector
            v-model="dialogForm.schoolTerm"
            @change="refreshSchoolYear"
            :checkAll="false"
          ></school-term-selector>
        </el-form-item>
        <el-form-item prop="grade" label="年级">
          <el-select
            size="small"
            value-key="grade"
            v-model="dialogForm.grade"
            placeholder="请选择年级"
            clearable
            :disabled="!userInfo.roleCodes.includes('admin')"
          >
            <el-option
              v-for="item in gradeOptions"
              :value="{ grade: item.grade, gradeName: item.gradeName }"
              :key="item.grade"
              :label="item.gradeName"
            ></el-option
          ></el-select>
        </el-form-item>
        <el-form-item prop="disciplineCode" label="学 科">
          <el-select
            size="small"
            value-key="grade"
            v-model="dialogForm.disciplineCode"
            placeholder="请选择学科"
            clearable
            :disabled="!userInfo.roleCodes.includes('admin')"
          >
            <el-option
              v-for="item in disciplineOptions"
              :value="item.disciplineCode"
              :label="item.disciplineName"
              :key="item.disciplineCode"
            ></el-option
          ></el-select>
        </el-form-item>
        <el-form-item prop="groupType" label="组别">
          <el-select
            size="small"
            value-key="grade"
            v-model="dialogForm.groupType"
            placeholder="请选择组别"
          >
            <el-option
              v-for="item in groupTypeOptions"
              :value="item.value"
              :label="item.label"
              :key="item.value"
            ></el-option
          ></el-select>
        </el-form-item>
        <el-form-item label="组长" prop="leader">
          <el-select
            size="small"
            value-key="teacherId"
            filterable
            v-model="dialogForm.leader"
            :filter-method="filterMethod"
            placeholder="请选择"
            clearable
            @visible-change="visibleChange"
            :disabled="!userInfo.roleCodes.includes('admin')"
          >
            <el-option
              v-for="item in userOptions"
              :key="item.userId"
              :label="item.userName"
              :value="{
                teacherId: item.userId,
                teacherName: item.userName,
              }"
            ></el-option
          ></el-select>
        </el-form-item>
        <el-form-item label="组员" prop="teacherList">
          <el-button type="text" @click="showSpeakPop = true">添加</el-button>
          <div class="scorll-list" v-if="dialogForm.teacherList.length > 0">
            <el-tag
              @close="tagSpeakRemove(tag.userId)"
              size="small"
              v-for="tag in dialogForm.teacherList"
              :key="tag.id"
              closable
              style="margin-right: 10px"
              >{{ tag.userName }}</el-tag
            >
          </div>
          <join-pop
            :modal="false"
            @close="showSpeakPop = false"
            @joinUsersChange="speakUserChange"
            :showJoinPop="showSpeakPop"
            v-if="showSpeakPop"
          ></join-pop>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer text-center">
        <el-button @click="dialogShow = false">取 消</el-button>
        <el-button type="primary" @click="onSave" :loading="saving"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import schoolYearSelector from "@/components/school/schoolYearSelector.vue";
import schoolTermSelector from "@/components/school/schoolTermSelector.vue";
import AuthorSelector from "@/components/school/authorSelector.vue";
import Pagination from "@/components/Pagination.vue";
import JoinPop from "@/components/common/JoinPop.vue";
import CardList from "@/components/researchGroup/CardList.vue";
import { mapGetters, mapState } from "vuex";
import { postData, postJson } from "@/http/fetch";
export default {
  components: {
    schoolYearSelector,
    schoolTermSelector,
    Pagination,
    AuthorSelector,
    JoinPop,
    CardList,
  },
  data() {
    var validatorJoinUser = (rule, value, callback) => {
      if (this.dialogForm.teacherList.length === 0) {
        return callback(new Error("请选择参与教师"));
      } else {
        callback();
      }
    };
    return {
      filterForm: {
        schoolYear: null,
        schoolTerm: null,
        keyword: null,
        checkStatus: null,
        disciplineCode: null,
        grade: null,
        size: 10,
        current: 1,
        total: 0,
      },
      userOptions: [],
      tableData: [],
      gradeOptions: [],
      disciplineOptions: [],
      pageLoading: false,
      dialogShow: false,
      saving: false,
      showSpeakPop: false,
      dialogForm: {
        id: null,
        schoolYear: null,
        schoolTerm: null,
        groupName: null,
        groupType: null,
        grade: null,
        disciplineCode: null,
        leader: null,
        teacherList: [],
      },
      groupTypeOptions: [
        { value: "yx", label: "优秀" },
        { value: "hg", label: "合格" },
        { value: "sf", label: "示范" },
      ],
      rules: {
        schoolYear: [
          { required: true, message: "请选择学年", trigger: "change" },
        ],
        schoolTerm: [
          { required: true, message: "请选择学期", trigger: "change" },
        ],
        groupName: [
          { required: true, message: "请输入教研组名称", trigger: "change" },
        ],
        groupType: [
          { required: true, message: "请选择组别", trigger: "change" },
        ],
        grade: [{ required: false, message: "请选择年级", trigger: "change" }],
        disciplineCode: [
          { required: false, message: "请选择学科", trigger: "change" },
        ],
        leader: [{ required: true, message: "请选择组长", trigger: "change" }],
        teacherList: [
          {
            validator: validatorJoinUser,
            message: "请选择组员",
            required: true,
            trigger: "blur",
          },
        ],
      },
    };
  },
  computed: {
    ...mapState(["userInfo", "isAdmin"]),
    ...mapGetters(["schoolCode"]),
  },
  mounted() {
    this.getData();
    this.getGradeList();
    this.getDisciplineFieldlList();
  },
  methods: {
    async getData() {
      this.loading = true;

      await postJson("/researchGroup/getResearchGroupInfoList", {
        schoolCodes: this.schoolCodes,
        operatorId: this.userInfo.userId,
        schoolCode: this.userInfo.orgCode || this.userInfo.schoolCode,
        pageNum: this.filterForm.current,
        pageSize: this.filterForm.size,
        schoolYear: this.filterForm.schoolYear,
        schoolTerm: this.filterForm.schoolTerm,
        disciplineCode: this.filterForm.disciplineCode,
        grade: this.filterForm.grade ? this.filterForm.grade.grade : null,
        keyword: this.filterForm.keyword,
        isAdmin: this.isAdmin / 1,
      })
        .then((res) => {
          this.tableData = res.records;
          this.filterForm.size = res.size;
          this.filterForm.total = res.total;
          this.filterForm.current = res.current;
        })
        .catch((e) => {
          this.tableData = [];
        })
        .finally(() => {
          this.loading = false;
        });
    },
    refresh() {
      this.filterForm.pageNum = 1;
      this.getData();
    },
    async getDisciplineFieldlList() {
      this.loading = true;
      return new Promise((resolve, reject) => {
        postData("/discipline/getDisciplinelList", {
          schoolCode: this.schoolCode,
        })
          .then((res) => {
            if (res.length) {
              res = res.map((m) => {
                return {
                  disciplineCode: m.disciplineCode,
                  disciplineName: m.disciplineName,
                };
              });
              this.disciplineOptions = res;
            } else {
              this.disciplineOptions = [];
            }
            resolve(res);
          })
          .catch((e) => {
            reject();
          })
          .finally(() => {
            this.loading = false;
          });
      });
    },
    async getGradeList() {
      this.loading = true;
      return new Promise((resolve, reject) => {
        postData("/school/getGradeList", { schoolCode: this.schoolCode })
          .then((res) => {
            let list = [];
            if (res.length) {
              list = res;
              this.gradeOptions = res;
              resolve(list);
            } else {
              this.gradeOptions = [];
              reject();
            }
          })
          .catch((e) => {
            reject(e);
          })
          .finally(() => {
            this.loading = false;
          });
      });
    },
    async getTeacherInfoList(query = "") {
      if (this.userInfo.orgCode != undefined && this.userInfo.orgCode != ''){
        return new Promise((resove, reject) => {
        postJson("/college/getTeacherInfoList", {
          isFree: 1,
          userName: query,
          schoolYear: this.dialogForm.schoolYear,
          schoolTerm: this.dialogForm.schoolTerm,
          groupCode: this.dialogForm.groupCode,
          orgCode: this.userInfo.orgCode
        }).then((res) => {
          if (res.length) {
            this.userOptions = res;
            resove(res);
          } else {
            this.userOptions = [];
            reject();
          }
        });
      });
      }else{
        return new Promise((resove, reject) => {
        postJson("/college/getTeacherInfoList", {
          isFree: 1,
          userName: query,
          schoolCode: this.schoolCode,
          schoolYear: this.dialogForm.schoolYear,
          schoolTerm: this.dialogForm.schoolTerm,
          groupCode: this.dialogForm.groupCode
        }).then((res) => {
          if (res.length) {
            this.userOptions = res;
            resove(res);
          } else {
            this.userOptions = [];
            reject();
          }
        });
      });
      }

    },
    async filterMethod(query) {

      if (this.userOptions.length == 0) {
        await this.getTeacherInfoList();
      } else {
        await this.getTeacherInfoList(query);
      }
    },
    visibleChange(bool) {
      if (bool) {
        if (!this.dialogForm.schoolYear) {
          this.$message({ message: "请选择学年", type: "warning" });
          return;
        }
        if (!this.dialogForm.schoolTerm) {
          this.$message({ message: "请选择学期", type: "warning" });
          return;
        }
        this.filterMethod("");
      }
    },
    refreshSchoolYear() {
      // this.dialogForm.leader = null;
      // this.filterMethod("");
    },
    onDialogClose() {
      this.dialogForm = {
        id: null,
        schoolYear: null,
        schoolTerm: null,
        groupName: null,
        groupType: null,
        grade: null,
        disciplineCode: null,
        leader: null,
        teacherList: [],
      };
      this.$refs.dialogForm.resetFields();
    },
    onReset() {
      this.filterForm.disciplineCode = null;
      this.filterForm.schoolYear = null;
      this.filterForm.schoolTerm = null;
      this.filterForm.keyword = null;
      this.filterForm.grade = null;
      this.refresh();
    },
    onAdd() {
      this.dialogShow = true;
      this.dialogForm = {
        id: null,
        schoolYear: null,
        schoolTerm: null,
        groupName: null,
        groupType: null,
        grade: null,
        disciplineCode: null,
        leader: null,
        teacherList: [],
      };
      this.userOptions = [];
    },
    async toPathEdit(groupCode) {

      await postData("/researchGroup/getResearchGroupInfo", {
        schoolCode: this.userInfo.orgCode || this.userInfo.schoolCode,
        groupCode,
      }).then((res) => {

        this.dialogForm = {
          id: res.id,
          teacherList: res.teacherList.map((u) => ({
            userId: u.teacherId,
            userName: u.teacherName,
          })),
          groupCode: res.groupCode,
          schoolYear: res.schoolYear,
          schoolTerm: res.schoolTerm,
          groupName: res.groupName,
          groupType: res.groupType,
          disciplineCode: res.disciplineCode,
          grade: {
            grade: res.grade,
            gradeName: res.gradeName,
          },
          leader: {
            teacherId: res.leaderId,
            teacherName: res.leaderName,
          },
        };
        this.dialogShow = true;
      });
      await this.getTeacherInfoList();
    },
    onSave() {

      this.$refs.dialogForm.validate((valid) => {
        if (valid) {
          this.saving = true;
          postJson("/researchGroup/saveOrUpdateResearchGroupInfo", {
            id: this.dialogForm.id ? this.dialogForm.id : null,
            groupCode: this.dialogForm.groupCode
              ? this.dialogForm.groupCode
              : null,
            disciplineCode: this.dialogForm.disciplineCode || null,
            disciplineName: this.dialogForm.disciplineCode ? this.disciplineOptions.find(
              (m) => m.disciplineCode == this.dialogForm.disciplineCode
            ).disciplineName : null,
            grade: this.dialogForm.grade?.grade || null,
            gradeName: this.dialogForm.grade?.gradeName || null,
            leaderId: this.dialogForm.leader.teacherId,
            leaderName: this.dialogForm.leader.teacherName,
            operatorId: this.userInfo.userId,
            schoolCode: this.userInfo.orgCode || this.userInfo.schoolCode,
            schoolYear: this.dialogForm.schoolYear,
            schoolTerm: this.dialogForm.schoolTerm,
            groupName: this.dialogForm.groupName,
            groupType: this.dialogForm.groupType,
            teacherList: this.dialogForm.teacherList.map((u) => ({
              teacherId: u.userId,
              teacherName: u.userName,
            })),
          })
            .then((res) => {
              this.dialogShow = false;
              this.$message.success("操作成功！");
              this.filterForm.pageNum = 1;
              this.getData();
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {
              this.saving = false;
            });
        }
      });
    },
    //添加教师
    speakUserChange(users) {
      users.forEach((i) => {
        if (
          !this.dialogForm.teacherList
            .map((item) => item.userId)
            .includes(i.userId)
        ) {
          this.dialogForm.teacherList.push(i);
        }
      });
    },
    //移除主讲人
    tagSpeakRemove(userId) {
      this.dialogForm.teacherList = this.dialogForm.teacherList.filter(
        (i) => i.userId != userId
      );
    },
    handleSizeChange(pageSize) {
      this.filterForm.current = 1;
      this.filterForm.size = pageSize;
      this.getData();
    },
    handleCurrentChange(curPage) {
      this.filterForm.current = curPage;
      this.getData();
    },
  },
};
</script>

<style lang="less" >
.authorSelector {
  margin-left: 0 !important;
}
.data-list {
  margin-top: 15px;
  background: #fff;
  padding: 15px;
  border-radius: 10px;
}
</style>
